import api from 'service/api'

const dponetAPI = api.create('dponet')

const get = async ({
  ssoCorporateGroupId = '',
  ssoCorporateGroupUserId = '',
  ...params
}) => {
  return await dponetAPI.get(
    `/sso_corporate_groups/${ssoCorporateGroupId}/sso_corporate_group_users/${ssoCorporateGroupUserId}`,
    { params },
  )
}

const create = async ({ ssoCorporateGroupId = '', userId = '' }) => {
  return await dponetAPI.post(
    `/sso_corporate_groups/${ssoCorporateGroupId}/sso_corporate_group_users`,
    { userId: userId },
  )
}

const destroy = async ({
  ssoCorporateGroupId = '',
  ssoCorporateGroupUserId = '',
}) => {
  return await dponetAPI.delete(
    `/sso_corporate_groups/${ssoCorporateGroupId}/sso_corporate_group_users/${ssoCorporateGroupUserId}`,
  )
}

const ssoCorporateGroupUsers = {
  get,
  create,
  destroy,
}

export default ssoCorporateGroupUsers
